<template>
  <div class="col-lg-12 col-md-12 col-sm-12" style="padding: 0">
    <div class="card">
      <div class="body">
        <div class="row clearfix">
          <div class="col-md-12 col-lg-12">
            <div
              class="panel-group"
              id="accordion_1"
              role="tablist"
              aria-multiselectable="true"
              v-for="(auth, index) in menus.viewFile"
              v-bind:key="auth"
            >
              <div class="panel panel-primary" @click="changeStatus(index)">
                <div class="panel-heading" role="tab" id="headingOne_1">
                  <h4 class="panel-title">
                    <a
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion_1"
                      href="javascript:void(0)"
                      aria-expanded="true"
                      aria-controls="collapseOne_1"
                    >
                      <span>{{ index + 1 }}단계 </span
                      >{{ menus.koreanText[index] }}
                    </a>
                  </h4>
                </div>
              </div>

              <div
                class="panel-collapse collapse in"
                :class="[whichStep[index] == true ? 'show' : '']"
                role="tabpanel"
                aria-labelledby="headingOne_1"
              >
                <div class="panel-body">
                  <menu-tab-component v-bind:is="menus.viewFile[index]" />
                  <!-- <dev-auth-input-fields /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

 
  </div>
</template>

<script>
// import DevAuthInputFields from '@/views/dev/auth/DevAuthInputFields'
// import DevAuthInputTestRequest from '@/views/dev/auth/DevAuthInputTestRequest'
// import DevAuthInputTest from '@/views/dev/auth/DevAuthInputTest'
import eventbus from "@/store/modules/devEventBus";


export default {
  props: ["menuType"],
  components: {
    DevAuthInputFields: () => import("@/views/dev/auth/DevAuthInputFields"),
    DevAuthInputTestRequest: () =>
      import("@/views/dev/auth/DevAuthInputTestRequest"),
    DevAuthInputTest: () => import("@/views/dev/auth/DevAuthInputTest"),
    DevOutput: () => import("@/views/dev/tools/DevOutput"),
    DevAuthRedirectUrl: () => import("@/views/dev/auth/DevAuthRedirectUrl"),
    DevAuthApplicationCredentials: () =>
      import("@/views/dev/auth/DevAuthApplicationCredentials"),
    DevAuth2Endpoint: () => import("@/views/dev/auth/DevAuth2Endpoint"),
    DevAuthSessionTokenExchange: () =>
      import("@/views/dev/auth/DevAuthSessionTokenExchange"),

    DevTriggerApiRequest: () =>
      import("@/views/dev/trigger/DevTriggerApiRequest"),
    DevActionInputTestRequest: () =>
      import("@/views/dev/action/DevActionInputTestRequest.vue"),
  },
  // el : '#cacaca',

  data() {
    return {
      menus: [],
      whichStep: [true, false, false, false, false],

      auths: [
        {
          name: "api",
          viewFile: [
            "DevAuthInputFields",
            "DevAuthInputTestRequest",
            "DevAuthInputTest",
          ],
          koreanText: ["필드 구성하기", "Request 테스트 구성하기", "테스트"],
        },
        {
          name: "oauth",
          viewFile: [
            "DevAuthInputFields",
            "DevAuthRedirectUrl",
            "DevAuthApplicationCredentials",
            "DevAuth2Endpoint",
            "DevAuthInputTest",
          ],
          koreanText: [
            "필드 구성하기",
            "Redirect Url 구성하기",
            "Credentials 입력하기",
            "Request 테스트 구성하기",
            "테스트",
          ],
        },
        {
          name: "session",
          viewFile: [
            "DevAuthInputFields",
            "DevAuthSessionTokenExchange",
            "DevAuthInputTestRequest",
            "DevAuthInputTest",
          ],
          koreanText: [
            "필드 구성하기",
            "세션 토큰 설정하기",
            "Request 테스트 구성하기",
            "테스트",
          ],
        },
        {
          name: "basic",
          viewFile: ["DevAuthInputTestRequest", "DevAuthInputTest"],
          koreanText: ["Request 테스트 구성하기", "테스트"],
        },
        {
          name: "digist",
          viewFile: [
            "DevAuthInputFields",
            "DevAuthInputTestRequest",
            "DevAuthInputTest",
          ],
          koreanText: ["필드 추가하기", "Request 테스트 구성하기", "테스트"],
        },
      ],
      triggers: [
        {
          name: "one",
          viewFile: ["DevTriggerApiRequest", "DevAuthInputTest", "DevOutput"],
          koreanText: ["Request 구성하기", "테스트", "아웃풋 설정"],
        },
      ],
      actions: [
        {
          name: "one",
          viewFile: [
            "DevActionInputTestRequest",
            "DevAuthInputTest",
            "DevOutput",
          ],
          koreanText: ["Request 구성하기", "테스트", "아웃풋 설정"],
        },
      ],

      acts: ["testRequest", "test"],
      modalClick: false,
      forms: [],
      modalDisabled: true,
    };
  },
  methods: {
    changeStatus(num) {
      this.whichStep[num] = !this.whichStep[num];
      this.whichStep.push();
    },

  

   

    // }
  },
  mounted() {},

  created() {
    
    console.log("created", this.$store.state.devStore.apiAuth);
    console.log("created", this.$store.state.devStore.apiData);
    var type = this.$store.state.devStore.apiData.apiType.replace(/"/gi, "");
    var name = this.$store.state.devStore.apiData.apiName.replace(/"/gi, "");

    //   this.checkType = this.$route.params.checkType;

    // this.checkName = name

    if (type == "authentication" && name == "Api Key") {
      this.menus = this.auths[0];
    } else if (type == "authentication" && name == "OAuth2") {
      this.menus = this.auths[1];
    } else if (type == "authentication" && name == "Auth Session") {
      this.check = "session";
      this.menus = this.auths[2];
    } else if (type == "authentication" && name == "Basic Auth") {
      //이거 뭐였지?
      this.menus = this.auths[3];
    } else if (type == "authentication" && name == "Digest Auth") {
      this.menus = this.auths[4];
    } else if (type == "trigger") {
      //   this.checkType = this.menuType;

      this.menus = this.triggers[0];
      // this.menus.push()
      console.log(this.menus, "Triggers");
    } else if (type == "action") {
      //   this.checkType = this.menuType;

      this.menus = this.actions[0];
      // this.menus.push()
      console.log(this.menus, "Actions");
    }
  },
  beforeDestroy() {
    eventbus.$off("method");
    eventbus.$off("url");
    eventbus.$off("param");
    eventbus.$off("headers");
    eventbus.$off("body");
    eventbus.$off("sendCodeDatas");
    eventbus.$off("sendCodeDatasTrueFalse");
  },
  // computed(){
  //     doneTodos(){
  //         return this.authClickTriggerOne.filter(!this.authClickTriggerOne => this.whichStep)
  //     }
  // }
};
</script>
